// src/App.tsx
import "./App.scss";
import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { appInsights } from "./Services/AppInsights";
import { AuthProvider } from "./Auth/AuthProvider";
import { PreCertPaths } from "./Shared/Utility/PreCertLocationHelper";
import AppRoutes from "./AppRoutes";

function App() {
  useEffect(() => {
    appInsights.load();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter basename={PreCertPaths.BaseName}>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
